// setTeacherId.js

export const setTeacherID = (teacherID) => ({
    type: 'SET_TEACHER_ID',
    payload: teacherID,
});